import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';

export default class MandantUIListener extends UIListener {

    constructor() {
        super();
    }
}

ComponentManager.setUIListener('MandantUIListener', MandantUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('ModulAViewExtension.UIListeners.TreeViewSelectorTest.MandantUIListener', MandantUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');